import i18n from '@/i18n';

const PLATFORM_TO_INTL = {
  us: 'en-US',
  mx: 'es-MX',
  ho: 'nl-NL',
  cz: 'cs-CZ',
  si: 'sl-SI',
  se: 'sv-SE',
  rs: 'sr-RS',
  si_lk: 'si-LK',
  zh_tw: 'zh-TW',
  fr_ca: 'fr-CA',
  pt_pt: 'pt-PT',
  es_mx: 'es-MX',
  fa_af: 'fa-AF',
};

function toIntlLocale(platformCode) {
  if (!platformCode) {
    return 'en-US';
  }

  const code = String(platformCode).trim().toLowerCase();
  if (PLATFORM_TO_INTL[code]) {
    return PLATFORM_TO_INTL[code];
  }

  if (code.includes('_')) {
    const [lang, region] = code.split('_');
    return `${lang}-${region.toUpperCase()}`;
  }

  return code;
}

function getActiveIntlLocale() {
  return toIntlLocale(i18n.global.locale.value);
}

export { toIntlLocale, getActiveIntlLocale };
